const { Core, Utils, Events, onBlazeLoad } = Global;
const { $fetch, $clone } = Utils;

const REQ_TEMPLATE_SELECTOR = '[data-req-content]';

customElements.define('product-recommendations-slider', class extends Core {
    propTypes = {
        'ref-product-id': String,
        'req-url': String,
        'req-section': String,
        'limit': Number
    };

    elements = {
        'slider': 'slideshow-inline-blaze'
    };

    render() {
        onBlazeLoad(this._handleRecommendations.bind(this));
    }

    async _handleRecommendations() {
        await customElements.whenDefined(this.elements.slider);
        try {
            const intent = this.getAttribute('intent') || 'related';

            let $content = await $fetch(this.prop('req-url'), {
                params: {
                    product_id: this.prop('ref-product-id'),
                    section_id: this.prop('req-section'),
                    limit: this.prop('limit'),
                    intent: intent
                },
                select: REQ_TEMPLATE_SELECTOR
            });

            // If complementary returned empty, fall back to related
            if (!$content && intent === 'complementary') {
                $content = await $fetch(this.prop('req-url'), {
                    params: {
                        product_id: this.prop('ref-product-id'),
                        section_id: this.prop('req-section'),
                        limit: this.prop('limit'),
                        intent: 'related'
                    },
                    select: REQ_TEMPLATE_SELECTOR
                });
            }

            if($content) {
                const $slides = $clone($content);
                const hasSlides = Array.from($slides.childNodes).some((node) => node.nodeType === 1);
                if (!hasSlides) throw new Error('No recommendation cards returned');

                this.closest('[data-cart-drawer-upsells]')?.removeAttribute('hidden');
                this._injectSlides($slides);
                this.setAttribute('data-recommendations-loaded', '');
                this.pub(Events.RECOMMENDATIONS_LOADED);
            } else {
                throw new Error('Missing template from request section');
            }
        } catch(e) {
            console.error(e);
            this.pub(Events.RECOMMENDATIONS_LOADED, {error: e});
            const $cartUpsells = this.closest('[data-cart-drawer-upsells]');
            $cartUpsells ? $cartUpsells.remove() : this.remove();
        }
    }

    _injectSlides($content) {
        this.$('slider').replaceSlides($content.childNodes);
    }
})
